(function () {
  'use strict'

  /**
   * @ngdoc module
   * @name thismomentGlowPage
   * @module thismoment.glow.component
   *
   * @description
   * The glow page that houses all the glow modules
   *
   * @example
     <pre><code>&#x3C;thismoment-glow-page id=&#x22;1&#x22;&#x3E;&#x3C;/thismoment-glow-page&#x3E;</code></pre>
   */
  var MODULE_NAME = 'thismoment.glow.component.glow-page'
  var templateUrl = require('./tpl/glow-page.html')

  require('./scss/glow-page.scss')
  require('bootstrap-icons/font/bootstrap-icons.scss')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-moment'),
      require('ng-meta').name
    ])
    .constant('momentTz', require('moment-timezone'))
    .component('thismomentGlowPage', {
      templateUrl: templateUrl,
      bindings: {
        pageConfig: '<'
      },
      controller: glowPageController
    })

  glowPageController.$inject = ['$rootScope', '$window', 'ngMeta', '$stateParams', 'amMoment', 'momentTz', 'analyticsSDK', 'SdkConfig', 'GlowConfig']
  function glowPageController ($rootScope, $window, ngMeta, $stateParams, amMoment, momentTz, analyticsSDK, SdkConfig, GlowConfig) {
    const vm = this

    vm.$onInit = glowPageInit

    function glowPageInit () {
      $window.moment = momentTz
      var backgroundImage = vm.pageConfig.get('background_image')
      vm.pageTitle = vm.pageConfig.get('share_title') || vm.pageConfig.get('title') || vm.pageConfig.get('name')
      vm.pageDescription = vm.pageConfig.get('share_description') || vm.pageConfig.get('description')

      if (vm.pageConfig.get('is_clc_approval') === true && SdkConfig.get('solution_hash')) {
        vm.trackEvent = analyticsSDK.setupEventTracking({})
        if ($stateParams.linkedAccount) {
          vm.trackEvent('CLC Authenticated', {
            'event trigger': 'clc request',
            'request id': SdkConfig.get('solution_hash')
          })
        } else {
          vm.trackEvent('CLC Opened', {
            'event trigger': 'clc request',
            'request id': SdkConfig.get('solution_hash')
          })
        }
      } else if (vm.pageConfig.get('is_cart') === true || SdkConfig.get('solution_hash')) {
        vm.trackEvent = analyticsSDK.setupEventTracking({})
        vm.trackEvent('Nexus Opened', {
        })
      } else {
        vm.trackPage = analyticsSDK.setupPageTracking({})
        vm.trackPage(vm.pageTitle)
      }

      analyticsSDK.setupExitTracking()

      ngMeta.setTitle(vm.pageTitle)
      ngMeta.setTag('description', vm.pageDescription)
      if (vm.pageConfig.get('share_image')) {
        ngMeta.setTag('ogImage', JSON.parse(vm.pageConfig.get('share_image')).large)
      }

      $rootScope.styles = {
        body: {
          'background-color': vm.pageConfig.get('background_color'),
          'background-image': backgroundImage ? "url('" + JSON.parse(backgroundImage).orig_file + "')" : null,
          'background-position': backgroundImage ? 'top center' : null
        },
        glow_page: {
          'max-width': vm.pageConfig.get('page_width') + 'px'
        }
      }

      vm.kiosk_mode = vm.pageConfig.get('kiosk_mode')
      vm.modules = vm.pageConfig.get('module_order').map(function (id) {
        return GlowConfig.getModule(id)
      })

      vm.header = vm.footer = false
      vm.main_content = []
      vm.modules.forEach(function (module) {
        switch (module.get('type')) {
          case 'module_header':
            vm.header = module
            break

          case 'module_footer':
            vm.footer = module
            break

          default:
            vm.main_content.push(module)
        }
      })

      vm.display_cart = displayCart()

      switch (vm.pageConfig.get('language_id')) {
        case 3:
          SdkConfig.set('language', 'es')
          amMoment.changeLocale('es')
          break

        case 4:
          SdkConfig.set('language', 'fr')
          amMoment.changeLocale('fr')
          break

        case 5:
          SdkConfig.set('language', 'jp')
          amMoment.changeLocale('ja')
          break

        case 6:
          SdkConfig.set('language', 'it')
          amMoment.changeLocale('it')
          break

        default:
          SdkConfig.set('language', 'en')
          amMoment.changeLocale('en')
      }
    }

    // TODO: Make this not display cart on end-user view.
    function displayCart () {
      var mediawall = vm.modules.filter(function (module) {
        return ['module_mediawall', 'module_multi_mediawall'].includes(module.get('type'))
      })

      // TODO: This needs to be handled more gracefully
      if ((mediawall.length)) {
        mediawall[0].set('sharing_card_enabled', GlowConfig.get('sharing_card_enabled'))
      }

      return (mediawall.length) ? (
        GlowConfig.get('playlist_cart_enabled') &&
                mediawall[0].get('playlist_cart_enabled')
      ) : false
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-page.js